import { Component } from '@angular/core';
import { DateRange, DateSelectorValue } from '../../date-selector/date-selector.component';

@Component({
  selector: 'app-date-selector-showcase',
  templateUrl: './date-selector-showcase.component.html',
  styleUrls: ['./date-selector-showcase.component.scss']
})
export class DateSelectorShowcaseComponent {
  basicDate: Date | null = null;
  prefilledDate: Date = new Date();
  rangeValue: DateRange = { start: null, end: null };
  prefilledRange: DateRange = {
    start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    end: new Date(new Date().getFullYear(), new Date().getMonth(), 15)
  };
  multipleDates: Date[] = [];
  errorDate: Date | null = null;
  requiredDate: Date | null = null;
  smallDate: Date | null = null;
  mediumDate: Date | null = null;
  largeDate: Date | null = null;

  minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  maxDate: Date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 15);

  onValueChange(label: string, value: DateSelectorValue): void {
    console.log(`${label} changed to`, value);
  }

  formatForLog(value: DateSelectorValue): string {
    if (value === null) {
      return 'null';
    }
    if (value instanceof Date) {
      return value.toDateString();
    }
    if (Array.isArray(value)) {
      return value.map(d => d.toDateString()).join(', ');
    }
    const startStr = value.start ? value.start.toDateString() : 'null';
    const endStr = value.end ? value.end.toDateString() : 'null';
    return `${startStr} → ${endStr}`;
  }
}
